import { ROFooter } from "layouts/RoFooter";
import { SearchInput } from "layouts/Form/SearchInput";
import { IconMenu } from "layouts/IconMenu";
import { FooterFilterMenuItems, MapFilterToApiKeys } from "./constants";
import { useState } from "react";

export const LinkedInsuracePayerFooter = (props) => {
  const { setLinkedPayers, linkedPayers, activeFilter,       // Now a prop
    setActiveFilter,    // Now a prop
    searchInput,        // Now a prop
    setSearchInput } = props;
  // const [activeFilter, setActiveFilter] = useState("Insurance Name");
  // const [searchInput, setSearchInput] = useState("");

  // Centralized filter logic helper
  const applyFilter = (filterVal, filterKey, listToFilter) => {
    if (filterVal === "" || !filterVal) {
      return listToFilter;
    }
    const searchFor = MapFilterToApiKeys[filterKey];
    return listToFilter.filter((payer) => {
      if (typeof payer[searchFor] === "string") {
        const uppercaseStr = payer[searchFor].toUpperCase();
        const uppercaseVal = filterVal.toUpperCase();
        // Use .includes() (modern JS) or .indexOf() !== -1 (legacy)
        return uppercaseStr.includes(uppercaseVal);
      } else {
        return payer[searchFor] === filterVal;
      }
    });
  };

  const handleSelectFilter = (selectedCol) => {
    setActiveFilter(selectedCol);
    setSearchInput("");
    setLinkedPayers(linkedPayers);
  };

  const handleSearch = (e) => { 
    const val = e.target.value; 
    setSearchInput(val); 

    // **IMPORTANT CHANGE:** Filter the *cache* (full list), not the current *displayed* list.
    const searchedRecords = applyFilter(val, activeFilter, linkedPayers);
    
    // Update the *displayed* list with the results
    setLinkedPayers(searchedRecords); 
  }; 

  // const handleSearch = (e) => {
  //   const val = e.target.value;
  //   setSearchInput(val);

  //   if (val === "" || !val) {
  //     setLinkedPayers(linkedPayers);
  //     return;
  //   }

  //   // Get the name of key from the API response which will help to filter the records
  //   const searchFor = MapFilterToApiKeys[activeFilter];

  //   const searchedRecords = linkedPayers.filter((payer) => {
  //     if (typeof payer[searchFor] === "string") {
  //       const uppercaseStr = payer[searchFor].toUpperCase();
  //       const uppercaseVal = val.toUpperCase();
  //       if (uppercaseStr.indexOf(uppercaseVal) !== -1) {
  //         return payer;
  //       }
  //     } else {
  //       if (payer[searchFor] === val) {
  //         return payer;
  //       }
  //     }
  //   });
  //   setLinkedPayers(searchedRecords);
  // };

  return (
    <ROFooter>
      <div className="footer-left-area p-3">
        <IconMenu
          menuItems={FooterFilterMenuItems}
          handleSelect={handleSelectFilter}
          selectedItem={activeFilter}
        />
        <SearchInput
          value={searchInput}
          placeholder={` Search by ${activeFilter}`}
          onChange={handleSearch}
          className="mt-1 mx-2"
        />
      </div>
    </ROFooter>
  );
};
